<template>
    <admin-header />
    <admin-menu />
    <div class="container mx-auto mt-8 sm:pl-20 sm:pr-10">
        <section class="grid md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-10 mb-20 dark:text-dark.textOnBkg">
            <div class="bg-white dark:bg-dark.tableBG p-10 rounded-lg shadow-light dark:shadow-dark relative cursor-pointer hover:shadow-2xl" @click="$router.push('/admin/agencies')">
                <font-awesome-icon icon="fas fa-refresh" class="cursor-pointer text-lg text-growth absolute right-0 top-0 p-10" :class="{'animate-spin':companies_data.loading}" @click="getCompanies_analytics()" />
                <font-awesome-icon icon="far fa-building" class="text-4xl text-leftPanelBG dark:text-dark.textOnBkg" />
                <div class="text-2xl font-bold mt-5">Agencies</div>
                <div class="mt-5 grid grid-cols-2 gap-5">
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">Total:</span><br /> {{companies_data.total ?? 0}}</div>
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-0.5">Active:</span><br /> {{companies_data.active ?? 0}}</div>
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3.5">New:</span><br /> {{companies_data.new ?? 0}}</div>
                </div>
            </div>
            <div class="bg-white dark:bg-dark.tableBG p-10 rounded-lg shadow-light dark:shadow-dark relative cursor-pointer hover:shadow-2xl" @click="$router.push('/admin/creators')">
                <font-awesome-icon icon="fas fa-refresh" class="cursor-pointer text-lg text-growth absolute right-0 top-0 p-10" :class="{'animate-spin': creators_data.loading}" @click="getCreators_analytics()" />
                <font-awesome-icon icon="fas fa-users" class="text-3xl text-leftPanelBG dark:text-dark.textOnBkg" />
                <div class="text-2xl font-bold mt-5">Creators</div>
                <div class="mt-5 grid grid-cols-2 gap-5">
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">Total:</span><br /> {{creators_data.total ?? 0}}</div>
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">Active:</span><br /> {{creators_data.active ?? 0}}</div>
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">New:</span><br /> {{creators_data.new ?? 0}}</div>
                </div>
            </div>
            <div class="bg-white dark:bg-dark.tableBG p-10 rounded-lg shadow-light dark:shadow-dark relative cursor-pointer hover:shadow-2xl" @click="$router.push('/admin/employees')">
                <font-awesome-icon icon="fas fa-refresh" class="cursor-pointer text-lg text-growth absolute right-0 top-0 p-10" :class="{'animate-spin':users_data.loading}" @click="getUsers_analytics()" />
                <font-awesome-icon icon="fas fa-users" class="text-3xl text-leftPanelBG dark:text-dark.textOnBkg" />
                <div class="text-2xl font-bold mt-5">Users</div>
                <div class="mt-5 grid grid-cols-2 gap-5">
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">Total:</span><br /> {{users_data.total ?? 0}}</div>
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">Active:</span><br /> {{users_data.active ?? 0}}</div>
                    <div class="text-xl font-semibold"><span class="text-base font-light pr-3">New:</span><br /> {{users_data.new ?? 0}}</div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
    import adminHeader from '@/components/admin/AdminHeader.vue';
    import adminMenu from '@/components/admin/AdminMenu.vue';
</script>
  
<script>
    import { getAnalytics } from '@/api/admin_api';
    export default {
        name: 'AdminDashboard',
        data() {
            return {
                companies_data: {
                    total: 0,
                    active: 0,
                    new: 0,
                    loading:false
                },
                creators_data: {
                    total: 0,
                    active: 0,
                    new: 0,
                    loading:false
                },
                users_data: {
                    total: 0,
                    active: 0,
                    new: 0,
                    loading:false
                }
            }
        },
        methods: {
            getCompanies_analytics() {
                this.companies_data.loading = true;
                getAnalytics(this.$cookies.get('admin_auth_token'), 'companies').then((response) => {
                    this.companies_data.total = response.count.total;
                    this.companies_data.active = response.count.active;
                    this.companies_data.new = response.count.new;
                    this.companies_data.loading = false;
                });
            },
            getCreators_analytics() {
                this.creators_data.loading = true;
                getAnalytics(this.$cookies.get('admin_auth_token'), 'creators').then((response) => {
                    this.creators_data.total = response.count.total;
                    this.creators_data.active = response.count.active;
                    this.creators_data.new = response.count.new;
                    this.creators_data.loading = false;
                });
            },
            getUsers_analytics() {
                this.users_data.loading = true;
                getAnalytics(this.$cookies.get('admin_auth_token'), 'users').then((response) => {
                    this.users_data.total = response.count.total;
                    this.users_data.active = response.count.active;
                    this.users_data.new = response.count.new;
                    this.users_data.loading = false;
                });
            }
        },
        created() {
            this.getCompanies_analytics();
            this.getCreators_analytics();
            this.getUsers_analytics();
        }
    };
</script>